import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "top-area-container" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = { class: "type" }
const _hoisted_4 = ["onClick"]

import { useThemeColor, useThemeColorWithAlpha } from '@/utils/theme'
import { TopContent } from '@/api/Models/CommunityHomeData'
import { useRouter } from 'vue-router'

export default /*@__PURE__*/_defineComponent({
  __name: 'TopArea',
  props: {
    topData: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "35caf6f0": (_unref(themeColorWithAlpha)),
  "98680ce0": (_unref(themeColor))
}))

const themeColor = useThemeColor()
const themeColorWithAlpha = useThemeColorWithAlpha(0.1)



const router = useRouter()
const handleJump = (id:string, boardType: number, boardId: string) => {
  if (+boardType === 1) {
    router.push({ path: '/comDetailLevel', query: { id } })
  } else {
    router.push({
      path: '/rollVideo',
      query: {
        sortType: 0,
        id,
        boardId
      }
    })
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topData, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "item",
        key: index
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('pc_community_top')), 1),
        _createElementVNode("div", _hoisted_3, _toDisplayString(+item.type ===1 ? _ctx.$t('pc_community_note') :  +item.type === 2 ? _ctx.$t('pc_community_article') : _ctx.$t('pc_community_album')), 1),
        _createElementVNode("div", {
          class: "title",
          onClick: ($event: any) => (handleJump(item.id, item.boardType, item.boardId))
        }, _toDisplayString(item.title), 9, _hoisted_4)
      ]))
    }), 128))
  ]))
}
}

})